module.exports = __webpack_public_path__ + "static/media/fluid-yellow.674af822.png";